module.exports = __webpack_public_path__ + "img/skate-quiz-single-female.8fbb2e6e.png";